import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=584d7d7d"
import script from "./BaseSidebar.vue?vue&type=script&lang=ts"
export * from "./BaseSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports